<template>
  <div class="channel-configure">
    <el-form
      class="custom-formScreen"
      ref="formScreen"
      label-width="100px"
      inline
      :model="formScreen"
    >
      <el-form-item label="国家" prop="countryId">
        <el-select v-model="formScreen.countryId" filterable>
          <el-option
            v-for="item in listCountry"
            :key="item.id"
            :label="item.countryName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物品类目" prop="categoryId">
        <el-select
          v-model="formScreen.categoryId"
          filterable
          @change="selectChange($event, 'productCategory')"
        >
          <el-option
            v-for="item in listProductCategory"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="中文品名" prop="productNameId">
        <el-select v-model="formScreen.productNameId" filterable value-key="id">
          <el-option
            v-for="item in listProductName"
            :key="item.id"
            :label="item.chineseName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物品类型" prop="itemId">
        <el-select v-model="formScreen.itemId" placeholder="请选择">
          <el-option
            v-for="item in listProductType"
            :key="item.id"
            :label="item.itemTypeName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="尺寸范围" prop="sizeId">
        <el-select v-model="formScreen.sizeId" placeholder="请选择">
          <el-option
            v-for="item in listSizeRange"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="重量范围" prop="weightId">
        <el-select v-model="formScreen.weightId" placeholder="请选择">
          <el-option
            v-for="item in listWeightRange"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物流" prop="channelData">
        <el-select
          v-model="formScreen.channelData"
          placeholder="请选择"
          value-key="itemTypeId"
          @change="selectChange($event, 'logistics')"
        >
          <el-option
            v-for="item in listLogistics"
            :key="item.id"
            :label="item.itemTypeName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道方式" prop="channelMethodData">
        <el-select v-model="formScreen.channelMethodData" value-key="value" filterable>
          <el-option
            v-for="item in listLogisticsMethod"
            :key="item.id"
            :label="item.title"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" @click="getListTable">搜索</el-button>
        <el-button type="primary" @click="formScreenReset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row style="margin-bottom: 20px;">
      <el-button type="primary" @click="openDialogComponents('Channel')">添加渠道</el-button>
      <el-button type="primary" @click="openDialogComponents('GoodsCategory')">物品类目</el-button>
      <el-button type="primary" @click="openDialogComponents('ProductName')">物品品名</el-button>
      <el-button type="primary" @click="openDialogComponents('Country')">添加国家</el-button>
      <el-button type="primary" @click="openDialogComponents('SizeRange')">尺寸范围</el-button>
      <el-button type="primary" @click="openDialogComponents('WeightRange')">重量范围</el-button>
    </el-row>

    <el-table :data="listTable" border>
      <el-table-column prop="categoryName" align="center" width="120" label="物品类目"></el-table-column>
      <el-table-column prop="chineseName" align="center" width="120" label="中文品名"></el-table-column>
      <el-table-column prop="countryName" align="center" width="120" label="国家"></el-table-column>
      <el-table-column align="center" width="200" label="尺寸范围">
        <template slot-scope="scope">
          <span>{{ scope.row.sizeName || '' }}</span>
          <span>{{ `(${scope.row.smallLength || 0}*${scope.row.smallWidth || 0}*${scope.row.smallHeight || 0}` }}</span>
          <span>~</span>
          <span>{{ `${scope.row.bigLenght || 0}*${scope.row.bigWidth || 0}*${scope.row.bigHeight || 0})` }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="140" label="重量范围">
        <template slot-scope="scope">
          <span>{{ scope.row.weightName || '' }}</span>
          <span>{{ `(${scope.row.smallValue || 0}~${scope.row.bigValue || 0})` }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="itemTypeName" align="center" width="120" label="物品类型"></el-table-column>
      <el-table-column prop="channelName" align="center" width="120" label="物流"></el-table-column>
      <el-table-column prop="chineseChannelWay" align="center" width label="渠道方式"></el-table-column>
      <el-table-column prop="updateTime" align="center" width="200" label="修改时间"></el-table-column>
      <el-table-column prop="name" align="center" width="100" label="启用状态">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isEnable" @change="switchChange($event, scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="openDialogComponents('Channel', scope.row)"
          >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <increase-channel
      ref="IncreaseChannel"
      :listProductCategory="listProductCategory"
      :listCountry="listCountry"
      :listProductName="listProductName"
      :listSizeRange="listSizeRange"
      :listWeightRange="listWeightRange"
      :listProductType="listProductType"
      :listLogistics="listLogistics"
      :listLogisticsMethod="listLogisticsMethod"
      @close="closeDialogComponents"
    />
    <increase-product-name ref="IncreaseProductName" @close="closeDialogComponents" />
    <increase-product-category ref="IncreaseGoodsCategory" @close="closeDialogComponents" />
    <increase-size-range ref="IncreaseSizeRange" @close="closeDialogComponents" />
    <increase-country ref="IncreaseCountry" @close="closeDialogComponents" />
    <increase-weight-range ref="IncreaseWeightRange" @close="closeDialogComponents" />
  </div>
</template>

<script>
import IncreaseChannel from './ChannelConfigureComponents/IncreaseChannel'
import IncreaseProductName from './ChannelConfigureComponents/IncreaseProductName'
import IncreaseProductCategory from './ChannelConfigureComponents/IncreaseProductCategory'
import IncreaseSizeRange from './ChannelConfigureComponents/IncreaseSizeRange'
import IncreaseCountry from './ChannelConfigureComponents/IncreaseCountry'
import IncreaseWeightRange from './ChannelConfigureComponents/IncreaseWeightRange'
import { ajaxPost, Baseurl } from '../../api/api/api'

export default {
  name: 'ChannelConfigure',
  components: {
    IncreaseChannel,
    IncreaseProductName,
    IncreaseProductCategory,
    IncreaseSizeRange,
    IncreaseCountry,
    IncreaseWeightRange
  },
  data() {
    return {
      formScreen: {
        categoryId: '',
        countryId: '',
        productNameId: '',
        // productNameId: '',
        sizeId: '',
        weightId: '',
        itemId: '',
        channelData: null,
        channelMethodData: null,
        // channelType: '',
        // channelName: '',
        // channelWay: '',
        // chineseChannelWay: '',
      },
      listTable: [],

      listProductCategory: [],
      listCountry: [],
      listProductName: [],
      listSizeRange: [],
      listWeightRange: [],
      listProductType: [],
      listLogistics: [],
      listLogisticsMethod: [],
    }
  },
  created() {
    this.getListTable()
    this.getListProductCategory()
    this.getListCountry()
    this.getListSizeRange()
    this.getListWeightRange()
    this.getListProductType()
    this.getListLogistics()
  },
  methods: {
    openDialogComponents(type, row = null) {
      this.$refs[`Increase${type}`].initComponents(row)
    },
    closeDialogComponents() {
      this.getListTable()
    },
    selectChange(event, type) {
      switch (type) {
        case 'productCategory':
          this.formScreen.productNameId = ''
          this.listProductName = []
          this.getListProductName()
          break
        case 'logistics':
          this.formScreen.channelMethodData = null
          this.listLogisticsMethod = []
          this.getListLogisticsMethod()
          break
        default:
          console.log('这里是default，检查一下type的值！')
          break
      }
    },
    formScreenReset() {
      this.listProductName = []
      this.listLogisticsMethod = []
      this.$refs.formScreen.resetFields()
      this.getListTable()
    },
    getListTable() {
      this.formScreen.channelType = this.formScreen.channelData && this.formScreen.channelData.itemTypeId
      this.formScreen.channelWay = this.formScreen.channelMethodData && this.formScreen.channelMethodData.value

      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsChannelList'
      const paramsData = this.formScreen
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          data.forEach(item => {
            item.isEnable = !!item.status
          })
          this.listTable = data
        }
      })
    },
    getListProductCategory() {
      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsCategoryList'
      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listProductCategory = data
        }
      })
    },
    getListCountry() {
      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsCountryList'
      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listCountry = data
        }
      })
    },
    getListProductName() {
      const API = Baseurl + 'logisticsConfigurationController/getLogisticsProductNamesByCategoryId'
      const paramsData = { categoryId: this.formScreen.categoryId }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listProductName = data
        }
      })
    },
    getListSizeRange() {
      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsSizeList'
      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          data.forEach(item => {
            item.title = `${item.sizeName}(${item.sizeValue})`
          })
          this.listSizeRange = data
        }
      })
    },
    getListWeightRange() {
      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsWeightList'
      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          data.forEach(item => {
            item.title = `${item.weightName}(${item.smallValue}~${item.bigValue})`
          })
          this.listWeightRange = data
        }
      })
    },
    getListProductType() {
      const API = Baseurl + 'purchaseController/selectItemList'
      const paramsData = { itemCode: "HYXUN0000001" }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listProductType = data
        }
      })
    },
    getListLogistics() {
      const API = Baseurl + "purchaseController/selectItemList";
      const paramsData = { itemCode: "HYXUN0000007" };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listLogistics = data;
        }
      });
    },
    getListLogisticsMethod() {
      const { itemTypeId: type } = this.formScreen.channelData;
      const API = Baseurl + 'logisticsController/getShippingMethodList'
      const paramsData = { type };

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          let itemTitleKey = "";
          let itemValueKey = "";
          if (type === "1") {
            itemTitleKey = "cnName";
            itemValueKey = "methodCode";
          } else if (type === "2") {
            itemTitleKey = "cname";
            itemValueKey = "code";
          } else if (type === "3") {
            itemTitleKey = "name";
            itemValueKey = "name";
          } else if (type === "5") {
            itemTitleKey = "cnName";
            itemValueKey = "code";
          }
          if (!itemTitleKey) return;
          this.logisticsTwoList = [];
          data.forEach(item => {
            const itemObj = {
              id: item.id || item.ytId,
              title: item[itemTitleKey],
              value: item[itemValueKey],
            };
            this.listLogisticsMethod.push(itemObj);
          });
        }
      })
    },
    switchChange(event, item) {
      const API = Baseurl + "logisticsConfigurationController/updateStatusById";
      const paramsData = {
        id: item.id,
        status: Number(event)
      };
      ajaxPost(API, paramsData).then(res => {
        const { code } = res.data;
        this.getListTable()
        if (code === 200) {
          this.$message.success('操作成功')
        } else {
          this.$message.success('操作失败')
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-configure {
  width: 98%;
}
</style>
